import { render } from "./BasicInfoSection.vue?vue&type=template&id=3734eba6&scoped=true"
import script from "./BasicInfoSection.vue?vue&type=script&lang=js"
export * from "./BasicInfoSection.vue?vue&type=script&lang=js"

import "./BasicInfoSection.vue?vue&type=style&index=0&id=3734eba6&scoped=true&lang=scss"
import "./BasicInfoSection.vue?vue&type=style&index=1&id=3734eba6&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3734eba6"]])

export default __exports__